import { render, staticRenderFns } from "./CapacitacionProfesionalPage.vue?vue&type=template&id=980fb6ce"
import script from "./CapacitacionProfesionalPage.js?vue&type=script&lang=js&external"
export * from "./CapacitacionProfesionalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports